export const homeDoctionary = {
  unknown: "Noma'lum",
}
